import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const NewSkillList = ({ skills, setSkillName, skillName }) => {
    return (
        <div className='flex flex-col mt-3'>
            {skills?.length > 0 ? skills?.map((item, index) => {
                const firstElement = index === 0
                const lastElement = index === skills?.length - 1
                const selected = item === skillName
                return (<div key={index} className={`${skills?.length === 1 ? 'rounded-xl' : firstElement ? 'rounded-t-xl' : lastElement ? 'rounded-b-xl' : ''} ${!lastElement && 'border-b border-[#355D85]'} flex items-center gap-2 justify-between ${selected ? 'bg-bg-13' : 'bg-bg-13/[15%]'} px-4 py-3 text-sm`} onClick={() => setSkillName && setSkillName(item)}>
                    {item}
                    {selected && <FontAwesomeIcon icon={faCheck} />}
                </div>
            )}) : <p className='text-center'>No Results Found</p>}
        </div>
    )
}

export default NewSkillList